/* eslint-disable import/prefer-default-export */
export const Config = {
  getConfigRequest: 'GET_CONFIG_REQUEST',
  getConfigSuccess: 'GET_CONFIG_SUCCESS',
  getConfigError: 'GET_CONFIG_ERROR',
};
